import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core'
import {ActivatedRoute} from '@angular/router'
import { NuclearObservable } from '../../nuclear-observable'
import { BaseComponent } from '../base.component'
import {Customer, Writer} from '../../types'
import { PostActions } from '../../actions/post-actions'
import { customerGetters } from '../../stores/customer-store'
import { WriterCustomerPostsListQueries, Post, Data } from './writer-customer-posts-list.queries'
import { customerPostStates } from 'src/logic/post-states'
import { get } from 'lodash-es'
import { QueryRef } from 'apollo-angular'

@Component({
  selector: 'writer-customer-posts-list',
  template: `
    <!-- EMPTY STATE -->
    <div *ngIf="!postsLoading && pages() === 1 && posts?.length === 0" class="profile-published-comment">
      You currently do not have any posts by this writer.
    </div>

    <div class="row mt-3">
      <div class="col-12" [class.top-buffer]="pages() === 1">
        <pagination-links *ngIf="pages() > 1" [currentPage]="getPage()" [pages]="pages()" [name]="'postsPage'"
                          [route]="['/dashboard', customer?.id, 'writer_profile', writer?.slug]"></pagination-links>

        <div class="loader" *ngIf="postsLoading">Loading...</div>

        <ng-template [ngIf]="!postsLoading">
          <div *ngFor="let post of posts; trackBy trackById" class="mb-3">
            <post-box
              [customer]="customer"
              [post]="post"
              (deprecatedStoreChange)="onDeprecatedStoreChange($event)"></post-box>
          </div>
        </ng-template>

        <pagination-links *ngIf="pages() > 1" [currentPage]="getPage()" [pages]="pages()" [name]="'postsPage'"
                          [route]="['/dashboard', customer?.id, 'writer_profile', writer?.slug]"></pagination-links>
      </div>
    </div>
  `
})
/**
 * Component: WriterCustomersPostsList
 * ====================================
 * Displays the post list by a writer for a customer or all customers on the account.
 * ALWAYS takes a customer input since this can currently only be displayed on a writer-profile in the context of a customer
 * If given ACCOUNT input, will load and display the posts for the entire account (all customers) instead of for 1 customer
 */
export class WriterCustomerPostsList extends BaseComponent implements OnInit {
  @Input() writer: Writer;
  @Input() customer: Customer;
  @Input() tab: string;
  @Output() postsLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();
  postsLoading: boolean;
  postsPage: number;
  posts: Post[]
  totalPosts: number = 0
  queryRef: QueryRef<Data>

  constructor(
    private route: ActivatedRoute,
    private queries: WriterCustomerPostsListQueries) {
    super()
  }

  // logic isn't sound. when we switch tabs, the page needs to be reset to 1
  getPage(): number {
    return this.postsPage || 1
  }

  ngOnInit(): void {
    const paramsObs = this.route.parent.queryParams.subscribe(queryParams => {
      this.postsPage = +queryParams['postsPage'] || 1
      if (this.writer && this.customer) {
        this.queryRef = this.queries.mainQuery({
          customerId: this.customer.id,
          writerId: this.writer.id,
          page: this.postsPage,
          perPage: 20,
          states: customerPostStates,
          order: 'lastTransitionAt DESC'
        })
        this.queryRef.valueChanges.subscribe(({loading, data, stale}) => {
          this.postsLoading = loading && stale
          if (data) {
            this.posts = get(data, 'customer.posts.entries', [])
            this.totalPosts = get(data, 'customer.posts.totalCount', 0)
          }
        })
      }
    })
    this.observers.push(paramsObs)
  }

  pages(): number {
    const total = this.totalPosts
    if (total) {
      return Math.ceil(total / 20)
    } else {
      return 1
    }
  }

  getCustomer(customerId: number): Customer {
    return NuclearObservable.currentValue<Customer>(customerGetters.customer(customerId), { toJS: true })
  }

  onDeprecatedStoreChange(postId: number): void {
    //TODO: update only this post if postId provided
    this.queryRef.refetch()
  }

  trackById(index: number, post: Post): number {
    return post.id
  }

}
